<form [formGroup]="aanmerkelijkBelangFg">
    @if (aanmerkelijkBelang.length > 0) {
        <div formArrayName="aanmerkelijkBelang">
            @for (item of aanmerkelijkBelang.controls; track $index; let i = $index) {
                <div [formGroupName]="i" class="row">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Omschrijving' : ''"
                                                    class="custom-input-250 col-auto"
                                                    formControlName="omschrijving"
                                                    id="omschrijving"
                    >
                    </snelstart-ui-text-form-control>
                    @if (this.incomeTaxEntity.aangifte?.biljetSoort !== 'C') {
                        <snelstart-ui-select-form-control (change)="saveForm()"
                                                          [label]="i === 0 ? 'Land' : ''"
                                                          [options]="optionsLandcodes"
                                                          [required]=true
                                                          class="custom-input-150 col-auto"
                                                          formControlName="landCode"
                        >
                        </snelstart-ui-select-form-control>
                    }
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]=0
                                                      [label]="i === 0 ? 'Aantal' : ''"
                                                      [required]=true
                                                      align="right"
                                                      class="me-1 custom-input-100 col-auto"
                                                      formControlName="aantalAandelen"
                                                      id="aantalAandelen"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Reguliere voordelen' : ''"
                                                      align="right"
                                                      class="custom-input-150 col-auto"
                                                      formControlName="reguliereVoordelen"
                                                      id="reguliereVoordelen"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Aftrekbare kosten' : ''"
                                                      align="right"
                                                      class="custom-input-150 col-auto"
                                                      formControlName="aftrekbareKosten"
                                                      id="aftrekbareKosten"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button (click)="this.showDialogVerkoop(i)"
                                         [class]="i === 0 ? 'pt-3 col-auto' : 'col-auto'"
                                         icon="plus"
                                         type="secondary">Verkoop AB
                    </snelstart-ui-button>
                    <snelstart-ui-button (click)="this.showDialogLenen(i)"
                                         [class]="i === 0 ? 'pt-3 col-auto' : 'col-auto'"
                                         icon="plus"
                                         type="secondary">Excessief lenen
                    </snelstart-ui-button>
                    <snelstart-ui-button (click)="verwijderRij(i)"
                                         [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                         icon="trash"
                                         iconType="light"
                                         id="buttonDeleteKosten"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            }
        </div>
    }
</form>

@if (aanmerkelijkBelang.length === 0) {
    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                         type="link">Aanmerkelijk belang invullen
    </snelstart-ui-button>
} @else {
    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                         type="link">Aanmerkelijk belang toevoegen
    </snelstart-ui-button>
}

@if (heeftTotaalSchulden) {
    <form [formGroup]="aanmerkelijkBelangFg">
        <div class="d-flex align-items-center gap-2">
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [minValue]="0"
                                              align="right"
                                              class="custom-input-250 pt-3"
                                              formControlName="eerderInHeffingBetrokkenSchuldBijVennootschappen"
                                              id="eerderInHeffingBetrokkenSchuldBijVennootschappen"
                                              label="Eerder belast i.v.m. excessief lenen"
                                              prefix="€"
            ></snelstart-ui-number-form-control>
            <div class="pt-3">
            <span snelstartUiTooltip="Het bedrag 'Eerder belast i.v.m. excessief lenen'
                betreft het totale fictief reguliere voordeel in voorgaande jaren, dus vóór {{ this.incomeTaxEntity.aangifte?.aangifteJaar! }}. Zie de toelichting voor
                meer informatie over dit onderwerp."> &#x24D8;</span>
            </div>
        </div>
    </form>
}

<snelstart-ui-dialog-definition [(visible)]="dialogVerkoopVisible" id="box2Verkoop" size="lg"
                                title="Gegevens verkoop aanmerkelijk belang">
    <snelstart-ui-dialog-body>
        <form [formGroup]="aanmerkelijkBelangFg">
            @if (aanmerkelijkBelang.length > 0) {
                <div formArrayName="aanmerkelijkBelang">
                    @for (item of aanmerkelijkBelang.controls; track $index; let i = $index) {
                        <div [formGroupName]="i">
                            @if (i === this.index) {
                                <div class="flex-container-dialog">
                                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                                      [decimals]="0"
                                                                      align="right"
                                                                      class="me-1 custom-input-200"
                                                                      formControlName="overdrachtsprijs"
                                                                      id="overdrachtsprijs"
                                                                      label="Overdrachtprijs"
                                                                      prefix="€"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                                <div>
                                    <div class="flex-container-dialog">
                                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                                          [decimals]="0"
                                                                          align="right"
                                                                          class="me-1 custom-input-200"
                                                                          formControlName="toerekenbareVerkrijgingsprijs"
                                                                          id="toerekenbareVerkrijgingsprijs"
                                                                          label="Verkrijgingsprijs"
                                                                          prefix="€"
                                        >
                                        </snelstart-ui-number-form-control>
                                    </div>
                                </div>

                                <div>
                                    <div class="flex-container-dialog">
                                        <snelstart-ui-select-form-control
                                                (change)="saveForm()"
                                                [options]="itemsVerkrijgingsprijs"
                                                class="me-1 custom-input-200"
                                                formControlName="verzoekDoorschuivenVerkrijgingsPrijs"
                                                id="verzoekDoorschuivenVerkrijgingsPrijs"
                                                label="Verzoek doorschuiven"
                                        >
                                        </snelstart-ui-select-form-control>
                                    </div>
                                </div>

                                <div>
                                    <div class="flex-container-dialog">
                                        <snelstart-ui-select-form-control
                                                (change)="saveForm()"
                                                [options]="itemsBeleggingsvermogen"
                                                class="me-1 custom-input-200"
                                                formControlName="vennootschapBevatBeleggingsVermogen"
                                                id="vennootschapBevatBeleggingsVermogen"
                                                label="Beleggingsvermogen"
                                        >
                                        </snelstart-ui-select-form-control>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<snelstart-ui-dialog-definition [(visible)]="dialogLenenVisible" id="box2Lenen" size="lg"
                                title="Gegevens excessief lenen">
    <snelstart-ui-dialog-body>
        <form [formGroup]="aanmerkelijkBelangFg">
            @if (aanmerkelijkBelang.length > 0) {
                <div formArrayName="aanmerkelijkBelang">
                    @for (item of aanmerkelijkBelang.controls; track $index; let i = $index) {
                        <div [formGroupName]="i">
                            @if (i === this.index) {
                                <div class="flex-container-dialog">
                                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                                      [decimals]="0"
                                                                      align="right"
                                                                      class="me-1 custom-input-200"
                                                                      formControlName="totaalSchuldenBijVennootschappen"
                                                                      id="totaalSchuld"
                                                                      label="Totaal schulden aan B.V."
                                                                      prefix="€"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                                <div class="flex-container-dialog">
                                    <snelstart-ui-number-form-control
                                            (change)="saveForm()"
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-200"
                                            formControlName="eigenWoningSchuldenBijVennootschappen"
                                            id="eigenWoningSchulden"
                                            label="Deel eigenwoningschuld"
                                            prefix="€"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel1" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button btn-x icon="check" id="save1" type="primary">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
